// A readable name for an internal user, the same everywhere: the display name, or else the part
// of the e-mail address before the @ with capitals (like initcap in SQL, public.feedback_person_name
// in migration 098). Shared by gv-crm-mcp and the project page.

export interface PersonLike {
  display_name?: string | null;
  email?: string | null;
}

export function personName(p: PersonLike | null | undefined): string | null {
  if (!p) return null;
  const shown = p.display_name?.trim();
  if (shown) return shown;
  const local = p.email?.split("@")[0]?.trim().toLowerCase();
  if (!local) return null;
  return local.replace(/(^|[^\p{L}\p{N}])(\p{L})/gu, (_m, before: string, letter: string) => before + letter.toUpperCase());
}
